import _ from 'lodash';
import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { IoCloseSharp } from 'react-icons/io5';
import SelectComponent, { CSSObjectWithLabel, SingleValue } from 'react-select';

import { SELECT_FILTER_STYLE } from 'app/constants';
import { OptionItem } from 'app/models/Common';
import cn from 'app/utils/ClassName';

import Button from '../Button';

interface Props {
  value: number | string | null;
  options: OptionItem[];
  placeholder?: string;
  className?: string;
  isClearable?: boolean;
  onValueChange: (item: SingleValue<OptionItem>) => void;
  onMenuScrollToBottom?: () => void;
  onInputChange?: (e: string) => void;
}
export const Select = ({
  options,
  value,
  placeholder,
  className,
  isClearable = false,
  onValueChange,
  onMenuScrollToBottom,
  onInputChange,
}: Props) => {
  const [localOptions, setLocalOptions] = useState<OptionItem[]>([]);
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    setLocalOptions((prev) => _.uniqBy([...prev, ...options], (option) => option.value));
  }, [options]);

  const foundOption = useMemo(() => localOptions.find(
    (option) => option.value === value,
  ), [localOptions, value]);

  const searchOnChange = (text: string) => {
    setInputValue(text);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    _.debounce(onInputChange ?? (() => {}), 500),
    [],
  );

  useEffect(() => {
    debounceSearch(inputValue);
  }, [inputValue, debounceSearch]);

  return (
    <div className={cn('relative flex w-full items-center border-b border-border-brand', className)}>
      <SelectComponent
        key={`selected-${foundOption}`}
        className="w-full min-w-[188px] pr-[22px] text-[14px] outline-none"
        value={foundOption}
        isMulti={false}
        placeholder={placeholder}
        onChange={onValueChange}
        inputValue={inputValue}
        noOptionsMessage={() => '沒有選項'}
        options={options}
        menuPosition="absolute"
        styles={{ ...SELECT_FILTER_STYLE, menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }) }}
        onMenuScrollToBottom={onMenuScrollToBottom}
        onInputChange={searchOnChange}
        menuPortalTarget={document.body}
        isClearable
      />
      {isClearable && value ? <Button variant="text" color="grey" onClick={() => { onValueChange(null); }} containerStyle="absolute right-5 top-1 size-4 text-text-light"><IoCloseSharp /></Button> : null}
      <IoIosArrowDown className="absolute right-1 top-1 size-4 text-text-light" />
    </div>
  );
};
